<template>
  <div class="dataBox">
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
          <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt="" />
          <br/>
          暂无数据
      </template>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column label="拒签方">
        <template slot-scope="scope">{{getSignList(scope.row)}}</template>
      </el-table-column>
      <el-table-column prop="signStatusTime" label="拒签时间"></el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div
              class="cursorPointer continueSign"
              v-if="getTaskId(scope.row.taskList,'CONFIRM')"
              @click="stopContract(scope.row,false)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">继续签</span>
            </div>
            <div
              class="cursorPointer break"
              @click="stopContract(scope.row,true)"
              v-if="getTaskId(scope.row.taskList,'CONFIRM')"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">终止</span>
            </div>
            <div class="cursorPointer " @click="toDetail(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">详情</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: []
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      this.tableData = data;
    },
    getTaskId(data, flag, all) {
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].actionCode === flag) {
            return data[i].taskId;
          }
        }
        return false;
      } else {
        return false;
      }
    },
    stopContract(row, flag) {
      this.$emit("stopContract", { data: row, flag: flag });
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    },
    getSignList(row) {
      let temp = [];
      if (row.signatoryList.length) {
        row.signatoryList.forEach(value => {
          temp.push(value.name);
        });
        return temp.join("，");
      } else {
        return "";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
